module.exports = "<th>Контактный телефон</th>\n<td>\n  <div class=\"advanced-browser__item\">\n    <span class=\"advanced-browser__label\">+7</span>\n    <input class=\"s-input s-input_length_l\"\n           ng-model=\"source.contact.value\"\n           maxlength=\"15\"\n           phone-parser>\n  </div>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/phone.html
// module id = 352
// module chunks = 0